import DIContainer from '@components/DependencyInjectionContainer.js';
/**
 * Registers a class under a given name in the global `s360` object.
 *
 * This is useful for dynamically loading business logic for forms which,
 * due to the architecture of the product, aren't compiled into the primary bundle.
 *
 * @param className - The name under which the class should be registered in the `s360` object.
 * @param classFactory - A function that creates a class and returns the class definition.
 *                          The class should extend or be of type `BaseClass`.
 *
 * @param singleton
 * @example
 * ```javascript
 * window.s360.registerClass('CustomerForm', () => {
 * 	class CustomerForm extends s360.Form {
 *
 * 	}
 *
 * 	return CustomerForm;
 * })
 * ```
 */
export function registerClass(className, classFactory, singleton = false) {
    const classConstructor = classFactory();
    className = className || classConstructor.name;
    if (singleton) {
        DIContainer.registerSingleton(className, classConstructor);
    }
    else {
        DIContainer.register(className, classConstructor);
    }
}
